module.exports = __webpack_public_path__ + "static/game-savognin-libellensprung-f3578813f953aeabbf87ad1305172f5f.png";